// src/app/hostel/hostel-page.module.ts
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HostelPageComponent } from '@app/hostel/hostel-page.component';
import { HostelPageRoutingModule } from '@app/hostel/hostel-page-routing.module';
import { HostelImageGridComponent } from '@app/hostel/hostel-image-grid/hostel-image-grid.component';
import { HostelDescriptionComponent } from '@app/hostel/hostel-description/hostel-description.component';
import { RoomListComponent } from '@app/hostel/room-list/room-list.component';
import { BookingWidgetComponent } from '@app/hostel/booking-widget/booking-widget.component';
import { RoomFiltersComponent } from '@app/hostel/room-filters/room-filters.component';
import { AmenitiesComponent } from '@app/hostel/amenities/amenities.component';
import { ReviewsComponent } from '@app/hostel/reviews/reviews.component';
import { CommentComponent } from '@app/hostel/comment/comment.component';
import { VotesComponent } from '@app/hostel/votes/votes.component';
import { HostelDetailsComponent } from '@app/hostel/hostel-details/hostel-details.component';
import { ContactHostelComponent } from '@app/hostel/contact-hostel/contact-hostel.component';
import { DirectivesModule } from '@app/directives/directives.module';
import { RoomTypePipe } from '@app/hostel/room-type.pipe';
import { LimitPipe } from '@app/hostel/limit.pipe';
import { FlagEmojiComponent } from '@app/hostel/flag-emoji.component';
import { RoomComponent } from '@app/hostel/room-list/room/room.component';
import { LoadingComponent } from '@app/loader/loader.component';
import { QRCodeModule } from 'angularx-qrcode';
import { qrCodeDialogComponent } from '@app/qr-code-dialog/qr-code-dialog.component';
import { HostelImageCarouselComponent } from '@app/hostel/hostel-image-carousel/hostel-image-carousel.component';
import { ImageCarouselComponent } from '@app/carousel/carousel.component';
import { BadgesComponent } from '@app/hostel/badges/badges.component';
import { BadgeComponent } from '@app/hostel/badges/badge/badge.component';
import { HostelDescriptionMobileComponent } from '@app/hostel/hostel-description/mobile/hostel-description-mobile.component';
import { ReviewsMobileComponent } from '@app/hostel/reviews/mobile/reviews-mobile.component';
import { CommentMobileComponent } from '@app/hostel/comment/mobile/comment-mobile.component';
import { RecommendationsComponent } from '@app/hostel/recommendations/recommendations.component';
import { BottomSheetComponent } from '@app/hostel/bottom-sheet/bottom-sheet.component';
import { LangPipe } from '@app/lang.pipe';
import { QrCodeCtaComponent } from 'qr-code-cta/qr-code-cta.component';
import { CdnPipe } from '@app/cdn.pipe';
import { FirstRenderDirective } from '@app/first-render.directive';
import { DayComponent } from '@app/when/day/day.component';
import { MonthPipe } from '@app/when/month.pipe';
import { DayToDatePipe } from '@app/when/day-to-date.pipe';
import { HostelRoomsComponent } from './hostel-rooms/hostel-rooms.component';
import { HostelFooterComponent } from './hostel-footer/hostel-footer.component';
import { WhenBottomSheetComponent } from '@app/when-bottom-sheet/when-bottom-sheet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { WhenMobileScrollComponent } from '@app/when-mobile-scroll/when-mobile-scroll.component';
import { PageComponent } from '@app/page/page.component';
import { HeaderComponent } from '@app/header/header.component';
import { WhereComponent } from '@app/where/where.component';
import { HostelTravelGuideComponent } from './hostel-travel-guide/hostel-travel-guide.spec';

@NgModule({
  declarations: [
    HostelPageComponent,
    HostelImageGridComponent,
    HostelDescriptionComponent,
    HostelDescriptionMobileComponent,
    BookingWidgetComponent,
    RoomFiltersComponent,
    AmenitiesComponent,
    ReviewsComponent,
    ReviewsMobileComponent,
    CommentComponent,
    CommentMobileComponent,
    VotesComponent,
    HostelDetailsComponent,
    ContactHostelComponent,
    RoomTypePipe,
    LimitPipe,
    FlagEmojiComponent,
    LoadingComponent, // move
    HostelImageCarouselComponent,
    BadgesComponent,
    BadgeComponent,
    RecommendationsComponent,
    BottomSheetComponent, // move and make generic
    HostelTravelGuideComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HostelPageRoutingModule,
    AngularSvgIconModule,
    FormsModule,
    NgOptimizedImage,
    DirectivesModule,
    QRCodeModule,
    ImageCarouselComponent,
    LangPipe,
    QrCodeCtaComponent,
    CdnPipe,
    FirstRenderDirective,
    DayComponent,
    MonthPipe,
    DayToDatePipe,
    HostelRoomsComponent,
    HostelFooterComponent,
    RoomListComponent,
    RoomComponent,
    qrCodeDialogComponent,
    WhenBottomSheetComponent,
    MatBottomSheetModule,
    WhenMobileScrollComponent,
    PageComponent,
    HeaderComponent,
    WhereComponent,
    ReactiveFormsModule,
  ],
  exports: [
    HostelPageComponent,
    RoomFiltersComponent, // Export RoomFiltersComponent
  ],
  providers: [
    // { provide: MatBottomSheet },
    // { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
  ],
})
export class HostelPageModule {}
